import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { getPreferentialFlights } from 'services';
import { divisionNumber, formatCity, getLocalStorage } from 'untils/auth';

const sec = 1000;

export const useGetDashboardEmptyLegs = () =>
  useQuery({
    queryKey: ['emptyLegs', 'dashboard-emptyLegs'],
    queryFn: getPreferentialFlights,
    select: (data) => {
      if (!data.data.emptyLegs) {
        return;
      }
      return data.data.emptyLegs.map((leg) => {
        const picture = leg.cityImage
          ? `${process.env.REACT_APP_RESOURCE_URL}/${leg.cityImage}`
          : '/imgs/webp/home/popular-city.webp';

        return {
          ...leg,
          path: `/emptyLegDetails/${leg.Id}`,
          picture,
          startCity: formatCity(leg.startCity),
          endCity: formatCity(leg.endCity),
          price: divisionNumber(leg.price || 0),
          startDate: dayjs(leg.startDate, 'YYYY-MM-DD').format('MMM DD, YYYY'),
          endDate: dayjs(leg.endDate, 'YYYY-MM-DD').format('MMM DD, YYYY'),
        };
      });
    },
    staleTime: sec * 60 * 30,
  });
